"use client";

import {
  ApolloClient,
  ApolloLink,
  HttpLink,
} from "@apollo/client";
import {
  NextSSRApolloClient,
  ApolloNextAppProvider,
  NextSSRInMemoryCache,
  SSRMultipartLink,
} from "@apollo/experimental-nextjs-app-support/ssr";
import { useSession } from "next-auth/react";

function makeClient(session) {
  //console.log('toke', session)
  const httpLink = new HttpLink({
      // https://studio.apollographql.com/public/spacex-l4uc6p/
      uri: process.env.NEXT_PUBLIC_API_BASE_URL,
      // fetchOptions: { next: { revalidate: 1 }},
      headers: {
        Authorization: (session?.user?.accessToken)?`Bearer ${session?.user?.accessToken}`:""
      }
  });

  return new NextSSRApolloClient({
    cache: new NextSSRInMemoryCache(),
    link:
      typeof window === "undefined"
        ? ApolloLink.from([
            new SSRMultipartLink({
              stripDefer: true,
            }),
            httpLink,
          ])
        : httpLink,
  });
}

export const ApolloWrapper = ({ children }) => {
  const { data: session, status, update } = useSession()
  //console.log('apollo sess', session)
  return (
    <ApolloNextAppProvider makeClient={() => makeClient(session)}>
      {children}
    </ApolloNextAppProvider>
  );
}

export default ApolloWrapper